module.exports = __webpack_public_path__ + "static/22-3d191e2a77c743ec38031c197a7c6db4.jpg";